import React from 'react';
import { noop } from 'lodash/fp';
import Textarea from '../../../../../common/components/Textarea';
import { JSON_ICON_TOOLTIP_TEXT } from '../../constants/texts';
import messengerAdsJSONHelpImage from 'assets/ads-json-help-new.png';
import './MessengerAdDetail.scss';

const JSONCodeTextArea = ({ code }) => (
  <div className="ad-details__input-container">
    <div className="ad-details__json-code-container">
      <div className="ad-details__field-title">Messenger Setup JSON</div>
      <div className="ad-details__help-text">
        {JSON_ICON_TOOLTIP_TEXT}
        <a
          href={messengerAdsJSONHelpImage}
          className="ad-details__info-image"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Image
        </a>
      </div>
      <Textarea
        className="ad-details__textarea ad-details__textarea--json"
        value={code}
        placeholder="JSON Code of your Ad"
        onChange={noop}
      />
    </div>
  </div>
);

export default JSONCodeTextArea;
